/** TODO: make language independent */
export enum VideoActionType {
  /** TODO: replace this type by null value */
  Default = '__default',
  Goal = 'Tor',
  Chance = 'Chance',
  Highlight = 'Highlight',
  RedCard = 'Platzverweis',
  IndoorGoal = 'Tor',
  IndoorHighlight = 'Highlight',
  Interview = 'Interview',
  Foul = 'Foul',
}
